/**
 * Navigation Section
 * Шапка сайта с логотипом, меню навигации и CTA кнопкой
 */
import { useState } from 'react';
import { Text, Button, Container } from '../components';

const styleClasses = {
  transparent: 'bg-transparent',
  solid: 'bg-white shadow-sm',
  blur: 'bg-white/80 backdrop-blur-md',
};

const alignmentClasses = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

export default function NavigationSection({ data, styles, isEditing = false }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const logo = data?.logo || { type: 'text', text: 'Название' };
  const links = data?.links || [];
  const ctaButton = data?.ctaButton || { enabled: false };
  const navStyle = data?.style || 'solid';
  const sticky = data?.sticky !== false && !isEditing; // Отключаем sticky в редакторе
  const alignment = data?.alignment || 'right';

  const bgClass = styleClasses[navStyle] || styleClasses.solid;
  const stickyClass = sticky ? 'sticky top-0 z-50' : 'relative';

  return (
    <nav
      className={`${bgClass} ${stickyClass} border-b border-border/50`}
      style={{
        backgroundColor: navStyle === 'solid' ? (styles?.backgroundColor || '#ffffff') : undefined,
      }}
    >
      <Container>
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center flex-shrink-0">
            {logo.type === 'image' && logo.imageUrl ? (
              <img
                src={logo.imageUrl}
                alt={typeof logo.text === 'object' ? logo.text.text : logo.text || 'Logo'}
                className="h-8 md:h-10 w-auto object-contain"
              />
            ) : (
              <Text
                as="span"
                data={typeof logo.text === 'object' ? logo.text : { text: logo.text || 'Название' }}
                defaults={{ size: 'xl', weight: 'bold', color: 'foreground' }}
              />
            )}
          </a>

          {/* Desktop Navigation */}
          <div className={`hidden md:flex items-center gap-8 flex-1 ml-12 ${alignmentClasses[alignment]}`}>
            {links.map((link) => (
              <a
                key={link.id}
                href={link.href || '#'}
                className="hover:opacity-70 transition-opacity"
              >
                <Text
                  as="span"
                  data={typeof link.text === 'object' ? link.text : { text: link.text }}
                  defaults={{ size: 'sm', weight: 'medium', color: 'secondary' }}
                />
              </a>
            ))}
          </div>

          {/* CTA Button (Desktop) */}
          {ctaButton.enabled && (
            <div className="hidden md:block ml-8">
              <Button
                href={ctaButton.href || '#'}
                variant={ctaButton.variant || 'primary'}
                size="sm"
              >
                {typeof ctaButton.text === 'object' ? ctaButton.text.text : ctaButton.text || 'Связаться'}
              </Button>
            </div>
          )}

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Меню"
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border/50">
            <div className="flex flex-col gap-2">
              {links.map((link) => (
                <a
                  key={link.id}
                  href={link.href || '#'}
                  className="px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <Text
                    as="span"
                    data={typeof link.text === 'object' ? link.text : { text: link.text }}
                    defaults={{ size: 'base', weight: 'medium', color: 'secondary' }}
                  />
                </a>
              ))}
              {ctaButton.enabled && (
                <div className="mt-4 px-4">
                  <Button
                    href={ctaButton.href || '#'}
                    variant={ctaButton.variant || 'primary'}
                    size="md"
                    fullWidth
                  >
                    {typeof ctaButton.text === 'object' ? ctaButton.text.text : ctaButton.text || 'Связаться'}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </Container>
    </nav>
  );
}
